import React, { useContext, useEffect } from 'react';
import { useFilteredListCountContext } from '../../utils/context';
import { ListContext } from '../ListContext';

// used to lift the filtered count state up to a parent
export default function (WrappedComponent) {
	const ReturnedComponent = function (props) {

		const {
			setFilteredCount,
			setFilteredFilter,
		} = useFilteredListCountContext() || {};
		const listContext = useContext(ListContext);
		const filter = listContext?.variables?.filter || null;

		useEffect(() => {
			// skip if front end as then it doesn't fetch anything
			if (!props.frontEnd && !props.skipSettingFilteredCount && setFilteredCount) {
				setFilteredCount(props.count);
				if (setFilteredFilter) {
					setFilteredFilter(filter);
				}
			}
		}, [filter, props.count, props.skipSettingFilteredCount, props.frontEnd, setFilteredCount, setFilteredFilter]);

		return (
			<WrappedComponent
				{...props}
			/>
		);
	};

	return ReturnedComponent;
}
